module.exports = __webpack_public_path__ + "img/no-image.15205a6f.png";